// extracted by mini-css-extract-plugin
module.exports = {"input":"RegisterDeviceInput_input__OXLHl"};